export * from '@fhs/routing/src/routes/(tabs)/rewards/offers/index';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/offers/index';
